module.exports = __webpack_public_path__ + "img/digital-solution.e8952b53.jpg";